import './LiveStream.css'
import * as React from 'react'
import { StreamBroadcastStatus, StreamConfig, StreamServiceType } from '../../configs/stream-entities'
import { ClassConfig } from '../../configs/stream-entities'
import { InteractionTypes } from '../../configs/interactions-entities'
import ReactPlayer from 'react-player'
import QnAList from './qna/QnAList'
import StudentsList from './students/StudentsList'
import BroadcastStatus from './broadcast/BroadcastStatus'
import CourseList from '../schedule/course-list/CourseList'
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import { v4 as UUID } from 'uuid'
import Timer, { TimerState } from './timer/Timer'
import * as Sentry from '@sentry/browser';
import * as moment from 'moment-timezone';

class LiveStreamState extends StreamConfig {
    public showQnA: boolean;
    public showVideo: boolean = true;
    public timerState: TimerState = TimerState.STOP;
}

class LiveStream extends React.Component<any, LiveStreamState> {
    private start: React.RefObject<HTMLButtonElement>;
    private stop: React.RefObject<HTMLButtonElement>;
    private waitingroom: React.RefObject<HTMLButtonElement>;
    private hideVideo: React.RefObject<HTMLButtonElement>;
    private liveStreamStatusTask: firebase.Unsubscribe;

    constructor(props: any) {
        super(props);
        this.state = new LiveStreamState();
        this.start = React.createRef<HTMLButtonElement>();
        this.stop = React.createRef<HTMLButtonElement>();
        this.waitingroom = React.createRef<HTMLButtonElement>();
        this.hideVideo = React.createRef<HTMLButtonElement>();
        this.enableQnA = this.enableQnA.bind(this);
        this.clearInteraction = this.clearInteraction.bind(this);
        this.startBroadcast = this.startBroadcast.bind(this);
        this.stopBroadcast = this.stopBroadcast.bind(this);
        this.startSimulator = this.startSimulator.bind(this);
        this.setCourseId = this.setCourseId.bind(this);
        this.openWaitingRoom = this.openWaitingRoom.bind(this);
        this.toggleVideoView = this.toggleVideoView.bind(this);
    }

    public componentDidMount() {
        this.liveStreamStatusTask = firebase.firestore().collection('config').doc("StreamConfig")
            .onSnapshot(doc => {
                const docData = doc.data();
                if (doc.exists && docData) {
                    const updateState = new LiveStreamState();
                    updateState.timerState = this.state.timerState;
                    updateState.activeService = docData.activeService;
                    updateState.activeURL = docData.activeURL;
                    updateState.interaction = docData.interaction;
                    updateState.broadcastStatus = docData.broadcastStatus;
                    updateState.streamId = docData.streamId;
                    updateState.simulation = docData.simulation;
                    updateState.teacherId = docData.teacherId;
                    updateState.courseId = docData.courseId;
                    updateState.selectedClassPublicationDate = docData.selectedClassPublicationDate;
                    updateState.replayDescription = docData.replayDescription;
                    this.setState(updateState);
                }
            });
    }

    public componentWillUnmount() {
        this.liveStreamStatusTask()
    }

    public render() {
        const notStreaming = (<div className="commands">Start a Stream from OBS</div>);
        const commands = (<div className="commands">
            <CourseList onItemSelected={this.setCourseId} isMultiple={false} defaultValue={this.state.courseId} />
            <div className='stream-info-row'>
                <div className='label'>CourseId</div>
                <div className='item'> { this.state.courseId || 'not set' }</div>
            </div>
            <div className='stream-info-row'>
                <div className='label'>TeacherId</div>
                <div className='item'>{ this.state.teacherId || 'not set' }</div>
            </div>
            <div className='stream-info-row'>
                <div className='label'>Course Time of Day</div>
                <div className='item'>{ this.state.selectedClassPublicationDate || 'not set' }</div>
            </div>
            {this.state.courseId.length > 0 &&
                <div>
                    <button className="controlButton" onClick={this.openWaitingRoom} ref={this.waitingroom}>Open waiting room</button>
                    <button className="controlButton" onClick={this.startBroadcast} disabled={this.state.broadcastStatus === StreamBroadcastStatus.BROADCAST || this.state.courseId.length < 1} ref={this.start}> Start broadcast</button>
                    <button className="controlButton" onClick={this.enableQnA} disabled={this.state.broadcastStatus === StreamBroadcastStatus.OFF || this.state.interaction === InteractionTypes.QNA}>Start Q&A</button>
                    <button className="controlButton" onClick={this.stopBroadcast} disabled={this.state.broadcastStatus !== StreamBroadcastStatus.BROADCAST && this.state.courseId.length < 1} ref={this.stop}> Stop broadcast</button>
                </div>
            }
        </div>)
        return (
            <div className="LiveStreamStatus">
                <BroadcastStatus />
                <div id="liveStreamControl">
                    <StudentsList streamId={this.state.streamId} />
                    <div className="videoBlock">
                        <QnAList streamId={this.state.streamId} qnaEnabled={this.state.interaction === InteractionTypes.QNA} />
                        <Timer action={this.state.timerState} />
                        <div className="videoBlock"><fieldset>
                            <legend>Broadcast</legend>
                            {this.state.activeURL.length > 0 ? commands : notStreaming}
                        </fieldset>
                            {(window.location.hostname.indexOf('local') > -1 || window.location.hostname.indexOf("dev") > -1) &&
                                <fieldset>
                                    <legend>Simulator</legend>
                                    <button className="controlButton" onClick={this.startSimulator}>{this.state.simulation ? 'Stop' : 'Start'} simulator</button>
                                </fieldset>
                            }
                        </div>
                        <div className="videoBlock">
                            <button ref={this.hideVideo} onClick={this.toggleVideoView} className="hideButton">{this.state.showVideo ? "Hide" : "Show"}</button>
                            <div className="target">&nbsp;</div>
                            {this.state.showVideo && <ReactPlayer className={'videoBlock videoPlayer'} url={this.state.activeURL} playing={true} controls={true} config={{
                                file: {
                                    attributes: {
                                        crossOrigin: 'anonymous'
                                    }
                                }
                            }} />}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    private toggleVideoView() {
        this.setState({ showVideo: !this.state.showVideo })
    }

    private setCourseId(clss: ClassConfig) {
        console.log('setCourseId', clss.id, clss.teacherId, clss.timeOfTheDay, clss.description);
        if(!clss.teacherId || !clss.id || !clss.timeOfTheDay) {
            const message = `Bad data: setCourseId() clss.teacherId: ${clss.teacherId} clss.id=${clss.id} clss.timeOfDay=${clss.timeOfTheDay} state.broadcastStatus=${this.state.broadcastStatus}`;
            alert(message);
            Sentry.captureMessage(message);
        }

        const courseDateNYC = moment.utc().tz('America/New_York').format('YYYY-MM-DD');
        const dateStringNYC = `${courseDateNYC} ${clss.timeOfTheDay}`;
        const classMoment = moment.tz(dateStringNYC, 'America/New_York');

        this.setState({
            courseId: clss.id,
            teacherId: clss.teacherId,
            replayDescription: clss.description || "",
            selectedClassPublicationDate: classMoment.toISOString()
        });
    }

    private openWaitingRoom() {
        firebase.firestore().doc('config/StreamConfig').update({
            broadcastStatus: StreamBroadcastStatus.WAITINGROOM,
            courseId: this.state.courseId,
            teacherId: this.state.teacherId,
            selectedClassPublicationDate: this.state.selectedClassPublicationDate,
            replayDescription: this.state.replayDescription || "",
        }).then(_ => {
            if(!this.state.teacherId) {
                Sentry.captureMessage(`Warning: openWaitingRoom() teacherId: ${this.state.teacherId} courseId=${this.state.courseId} StreamBroadcastStatus.WAITINGROOM`);
            }
            return firebase.firestore().collection('classes').doc(this.state.streamId).update({
                courseId: this.state.courseId,
                teacherId: this.state.teacherId,
                openWaitingRoomTime: new Date(),
                selectedClassPublicationDate: this.state.selectedClassPublicationDate,
                replayDescription: this.state.replayDescription || ""
            });
        }).then(_ => {
            if (this.waitingroom.current !== null) {
                this.stop.current!.disabled = false;
                this.waitingroom.current!.disabled = true;
            }
        })
    }

    private startSimulator() {
        if (this.state.simulation) {
            // currently simulating so we stop
            firebase.firestore().doc('config/StreamConfig').set(Object.assign({}, new StreamConfig())).then(_ => {
                this.setState({ simulation: false })
            })
        } else {
            // Start a simulation
            const id = UUID();
            const obj = new StreamConfig();
            obj.activeService = StreamServiceType.SVS;
            obj.activeURL = 'https://bitdash-a.akamaihd.net/content/MI201109210084_1/m3u8s/f08e80da-bf1d-4e3d-8899-f0f6155f6efa.m3u8';
            obj.streamId = id;
            obj.broadcastStatus = StreamBroadcastStatus.WAITINGROOM;
            obj.simulation = true;
            firebase.firestore().doc('config/StreamConfig').set(Object.assign({}, obj)).then(_ => {
                firebase.firestore().collection('classes').doc(id).set({
                    isReady: false,
                    playbackURL: "",
                    thumbURL: ""
                })
            }).then(_ => {
                this.setState({ simulation: true })
            })
        }
    }

    private startBroadcast() {
        firebase.firestore().doc('config/StreamConfig').update({ broadcastStatus: StreamBroadcastStatus.BROADCAST }).then(_ => {
            this.stop.current!.disabled = false
            this.start.current!.disabled = true
        }).then(_ => {
            console.log(this.state.streamId)
            return firebase.firestore().collection('classes').doc(this.state.streamId).update({ startTime: new Date() })
        })
        this.setState({ timerState: TimerState.START })
    }

    private stopBroadcast() {
        const streamId = this.state.streamId
        const resetState = Object.assign({}, new StreamConfig())
        firebase.firestore().doc('config/StreamConfig').update(resetState).then(_ => {
            if (this.stop.current !== null) {
                this.stop.current!.disabled = true
            }
            if (this.start.current !== null) {
                this.start.current!.disabled = false
            }
            if(this.waitingroom.current !== null) {
                this.waitingroom.current!.disabled = false
            }
            this.setState(resetState);
        }).then(_ => {
            return firebase.firestore().collection('classes').doc(streamId).update({ endTime: new Date() })
        }).catch(err => {
            alert(err)
        })
        this.setState({ timerState: TimerState.STOP })
    }

    private enableQnA() {
        const streamId = this.state.streamId
        firebase.firestore().collection('config').doc("StreamConfig").update({
            "interaction": InteractionTypes.QNA
        }).then(_ => {
            return firebase.firestore().collection('classes').doc(streamId).update({ startQnATime: new Date() })
        }).then(_ => {
            this.setState({ showQnA: true } as LiveStreamState)
        })
    }

    private clearInteraction() {
        firebase.firestore().collection('config').doc("StreamConfig").update({
            "interaction": InteractionTypes.NONE
        }).then(_ => {
            this.setState({ showQnA: false } as LiveStreamState)
        })
    }
}

export default LiveStream


// WEBPACK FOOTER //
// ./src/components/stream/LiveStream.tsx